/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var anchorMarginTop = 250;
  var anchorGlobals = [];

  var CELENE = {
    navigation : function(){

      windowScrollTop = $(window).scrollTop();

      //MINIMIFY MENU ON SCROLL
      if (windowScrollTop > 150) {
        $('#navigation, #sous-navigation').addClass('minify');
      } else {
        $('#navigation, #sous-navigation').removeClass('minify');
      }
      //END MINIMIFY MENU ON SCROLL


      //ACTIVE ANCHOR ON SCROLL
      anchorGlobals.forEach(function(element) {
        if (windowScrollTop >= element[1] && windowScrollTop <= element[2]) {
          aAnchorActive = '#sous-navigation a:eq('+element[0]+')';
          if($(aAnchorActive).hasClass('active') === false) {
            $('#sous-navigation a').removeClass('active');
            $(aAnchorActive).addClass('active');
          }
        }
      });
      //ENDACTIVE ANCHOR ON SCROLL

    },
    nextslide : function(){

      //NEXT HOME SLIDER
      $('.celene-slide.active').each(function(){
        $(this).fadeOut(function(){
          $(this).removeClass('active');
        });
        var nextSlide = $(this).next('.celene-slide');
        if(!nextSlide.length) {
          nextSlide = $(".celene-slide:first");
        }
        nextSlide.fadeIn(function(){
          nextSlide.addClass('active');
        });
      });
      //END NEXT HOME SLIDER

    },
    prevslide : function(){

      //NEXT HOME SLIDER
      $('.celene-slide.active').each(function(){
        $(this).fadeOut(function(){
          $(this).removeClass('active');
        });
        var prevSlide = $(this).prev('.celene-slide');
        if(!prevSlide.length) {
          prevSlide = $(".celene-slide:last");
        }
        prevSlide.fadeIn(function(){
          prevSlide.addClass('active');
        });
      });
      //END NEXT HOME SLIDER

    },
    setCookie : function(key, value) {

      //SET COOKIE
      var expires = new Date();
      expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000));
      document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
      //END SET COOKIE

    },
    getCookie : function(key) {

      //GET COOKIE
      var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
      return keyValue ? keyValue[2] : null;
      //END GET COOKIE

    },
    googleMap : function() {

      //Google Maps API
      var celeneMap = $('#googleMap'),
      lat = celeneMap.attr('data-lat'),
      lng = celeneMap.attr('data-lng');
      var myLatlng = new google.maps.LatLng(lat, lng);

      var map = new google.maps.Map(document.getElementById('googleMap'), {
        center: myLatlng,
        scrollwheel: false,
        zoom: 15
      });

      var marker = new google.maps.Marker({position: myLatlng, map: map});
      //END Google Maps API

    }
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $(document).on('click','body.noOverflow:not(.noAge)',function(event){
          var target = $( event.target );
          if( target.is( 'body') || target.is( '.modalCelene') || target.is( '.modalCremant') ) {
            $('.modalCelene,.modalCremant').fadeOut();
            $('#headerCart').removeClass('active');
            $('body').removeClass('noOverflow');
          }
        });

        //AGE LEGAL
        if(!CELENE.getCookie('celene') || CELENE.getCookie('celene') !== '1') {
          $('body').addClass('noAge').addClass('noOverflow');
          $('#modalCeleneAge').show();
        }
        $('#ageOui').on('click',function(){
          CELENE.setCookie('celene','1');
          $('body').removeClass('noAge').removeClass('noOverflow');
          $('#modalCeleneAge').fadeOut();
        });
        $('#ageNon').on('click',function(){
          $('#ageSorry').fadeIn();
        });
        //END AGE LEGAL


        //NAVIGATION AND MINIMIFY MENU
        CELENE.navigation();
        $(window).on('scroll',function(){
          CELENE.navigation();
        });
        //END NAVIGATION AND MINIMIFY MENU

        //PRIMARY MENU OVERLAY
        $('.navigation').on('click', '#hamburger', function(){
          $('#overlay-menu').addClass('active');
        });
        $('.navigation').on('click', '#cross', function(){
          $('#overlay-menu').removeClass('active');
        });
        $('.navigation').on('click', '#shop', function(){
          if($(this).attr('href') === undefined) {
            $('body').addClass('noOverflow');
            $('#headerCart').addClass('active');
            return false;
          }
        });
        $('footer').on('click', '#shop-footer', function(){
          if($(this).attr('href') === undefined) {
            $('body').addClass('noOverflow');
            $('#headerCart').addClass('active');
            return false;
          }
        });
        $('#headerCartClose').on('click', function(){
          $('body').removeClass('noOverflow');
          $('#headerCart').removeClass('active');
          return false;
        });
        //END PRIMARY MENU OVERLAY


        //INIT ANCHORS
        if($('#sous-navigation').length) {
          $('#sous-navigation a').each(function(index){
            var divAnchor = $(this).attr('href');
            if($(divAnchor).length) {
              anchorGlobals.push([index,$(divAnchor).offset().top - anchorMarginTop,$(divAnchor).offset().top - anchorMarginTop + $(divAnchor).height()]);
            }
          });
        }
        //END INIT ANCHORS


        //ANCHOR NAVIGATION
        $('a:not(.celene-lienbouteille,.openModalCelene,.nav-link,.nextModalCremant,.prevModalCremant)').on('click', function () {
          if($(this).attr('href') && $(this).attr('href').substring(0,1) === '#') {
            var anchorTop = 0;

            var anchor = $(this).attr('href');
            if(anchor !== '#top') {
              anchorTop = $(anchor).offset().top  - anchorMarginTop;
            }

            $('html, body').animate({
              scrollTop: anchorTop
            }, 1000);
            return false;
          }
        });
        //END ANCHOR NAVIGATION


        //OPEN MODALS
        $('.celene-lienbouteille').on('click', function(){
          //Catégories désactivées
          if($(this).parent('.product').hasClass('inactive')) {
            return false;
          }
          //Tous les autres cas
          var idModal = $(this).attr('href');
          $(idModal).fadeIn();
          $('body').addClass('noOverflow');
          return false;
        });
        //END OPEN MODALS


        //MODALS CREMANTS
        $('.closeModalCremant').on('click', function(){
          $('.modalCremant').fadeOut();
          $('body').removeClass('noOverflow');
          return false;
        });
        $('.prevModalCremant, .nextModalCremant').on('click', function(){
          var idModal = $(this).attr('href');
          $(idModal).fadeIn(function(){
            $('.modalCremant').not(idModal).fadeOut();
          });
          return false;
        });
        //END MODALS CREMANTS


        //CAROUSELS CREMANTS
        if($('.carouselCremants').length) {
          $('.carouselCremants .masqueCarousel').fadeOut();
          $('.active-carousel').on('click', function(){
            var idModal = $(this).attr('href');
            if($(idModal).find('.carouselCremants').length) {
              $('.carouselCremants .masqueCarousel').show();
              $('.carousel').slick('refresh');
              setTimeout(function(){$('.carouselCremants .masqueCarousel').fadeOut();},500);
            }
          });
        }
        //END CAROUSSEL CREMANTS


        //MODALS CELENE
        $('.openModalCelene').on('click', function(){
          var idModal = $(this).attr('href');
          var returnCarouselCocktail = false;
          if($(this).hasClass('initCarouselCocktail')) {
            returnCarouselCocktail = true;
          }
          $('body').addClass('noOverflow');
          $(idModal).fadeIn(function(){
            if(returnCarouselCocktail) {
              $(idModal).find('.carouselCocktail:not(.slick-slider)').slick({
                slidesToShow: 1
              });
            }
          });
          return false;
        });
        $('.closeModalCelene').on('click', function(){
          $('body').removeClass('noOverflow');
          $('.modalCelene').fadeOut(function(){
            var _this = $(this);
            // if video player > remove video on close
            if(_this.attr('id') === 'modalCeleneVideo'){
              _this.find('iframe').attr('src', _this.find('iframe').attr('src'));
            }
          });
          return false;
        });
        //END MODALS CELENE


        //COLLAPSE TEXT ON MOBILE
        $('.collapse-xs-down').after('<p class="col-12 p-2 text-center hidden-sm-up"><a class="collapse-slide-down text-uppercase">EN LIRE PLUS &rangle;</a></p>');
        $(document).on('click','.collapse-slide-down', function(){
          var divToHide = $(this).parent('p').prev('.collapse-xs-down');
          if(divToHide.css('display') === 'block')
          {
            $(this).html('EN LIRE PLUS ⟩');
          } else {
            $(this).html('⟨ RÉDUIRE');
          }
          divToHide.slideToggle();
        });
        //END COLLAPSE TEXT ON MOBILE


        //CAROUSELS
        $('.carousel').slick({
          centerMode: true,
          centerPadding: '300px',
          slidesToShow: 1,
          responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
              centerPadding: '20px'
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              centerPadding: '0px'
            }
          }
          ]
        });
        //END CAROUSELS


        //AOS (animations on scroll)
        AOS.init({duration: 1500});
        //END AOS


        //GOOGLE MAPS INIT
        if($('#googleMap').length) {
          CELENE.googleMap();
        }
        //END GOOGLE MAPS INIT

        //PLUS AND MINUS
        $(document).on('click', '.plus', function(e) {
          $input = $(this).prev('input.qty');
          var val = parseInt($input.val());
          // $input.val( val+1 );
          $input.val( val+1 ).change();
          $("[name='update_cart']").trigger("click");
        });

        $(document).on('click', '.minus', function(e) {
          $input = $(this).next('input.qty');
          var val = parseInt($input.val());
          if (val >= 1) {
              // $input.val( val-1 );
              $input.val( val-1 ).change();
          }
          $("[name='update_cart']").trigger("click");
        });
        //END PLUS AND MINUS

      //   if(_this.hasClass('more')){
      //     new_quantity = current_quantity+1;
      //   }
      //   else if(_this.hasClass('less') && current_quantity > 1){
      //     new_quantity = current_quantity-1;
      //   }
      // quantityCartItem(item_key, new_quantity);

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        var intervalSlider = setInterval(CELENE.nextslide,10000);
        $('.next-slide').on('click',function(){
          clearInterval(intervalSlider);
          CELENE.nextslide();
          intervalSlider = setInterval(CELENE.nextslide,10000);
        });
        $('.prev-slide').on('click',function(){
          clearInterval(intervalSlider);
          CELENE.prevslide();
          intervalSlider = setInterval(CELENE.nextslide,10000);
        });
      }
    },
    'oenotourisme': {
      init: function() {
        // JavaScript to be fired on the oenotourisme us page
        $('.nav-link').on('click', function(){
          var idNav = $(this).attr('href')+'-image';
          console.log($(this).attr('href'));
          if($(idNav).length) {
            $('.nav-image').removeClass('active');
            $(idNav).addClass('active');
          }
        });
        // Update 'book' button destination from languages selector.
        $( '#booking-lang-selector' ).change(function() {
          var _this = $(this),
              selector_val = _this.find(":selected").val(),
              book_button = $('#booking-button'),
              book_button_link = book_button.children('a');

          if (selector_val === '0') { book_button.addClass('d-none'); }
          else {
            book_button.removeClass('d-none');
            book_button_link.attr('href', selector_val);
          }
        });
      }
    },
    'woocommerce': {
      init: function() {
        // Shop filters
        var group = $('.filter-button-group');
        var cardsContainer = $('.row.products');
        var $masonry = cardsContainer.isotope({
            itemSelector: '.grid-item',
            percentPosition: true,
            masonry: {
              columnWidth: '.grid-sizer'
            }
        });

        // filter items on button click
        group.on( 'click', 'li', function(e) {
          e.preventDefault();
          group.find('li').removeClass('active');
          $(this).addClass('active');
          var filterValue = $(this).attr('data-filter');
          $masonry.isotope({ filter: filterValue });
        });

        //INIT NAVIGATION MODALS
        function initModalNavigation(idModal, postProduct) {

          var firstModal = $('.product:visible').first().children('.celene-lienbouteille').attr('href');
          var lastModal = $('.product:visible').last().children('.celene-lienbouteille').attr('href');

          var thisModal = parseInt( $('.products .grid-item:visible').index(postProduct.parent('.product').parent('.grid-item')) ) + 1;
          var lengthModals = $('.product:visible').length;

          prevModal = postProduct.parent('.product').parent('.grid-item').prevAll(".grid-item:visible").first().find('.celene-lienbouteille').attr('href');
          if(prevModal === undefined) { prevModal = lastModal; }

          nextModal = postProduct.parent('.product').parent('.grid-item').nextAll(".grid-item:visible").first().find('.celene-lienbouteille').attr('href');
          if(nextModal === undefined) { nextModal = firstModal; }

          idModal.find('.prevModalCremant').attr('href',prevModal);
          idModal.find('.thisModalCremant').html(thisModal+'/'+lengthModals);
          idModal.find('.nextModalCremant').attr('href',nextModal);

        }

        if($('.modalCremant:visible').length > 0) {

          $('body').addClass('noOverflow');

          var hrefModal = '#'+$('.modalCremant:visible').attr('id');
          var postProduct = '.post-'+hrefModal.substring(10)+' > .celene-lienbouteille';
          initModalNavigation( $(hrefModal), $(postProduct) );

        }

        $('.celene-lienbouteille').on('click', function(){

          var hrefModal = $(this).attr('href');
          initModalNavigation( $(hrefModal), $(this) );

          return false;

        });
        $('.prevModalCremant, .nextModalCremant').on('click', function(){

          var hrefModal = $(this).attr('href');
          var postProduct = '.post-'+hrefModal.substring(10)+' > .celene-lienbouteille';
          initModalNavigation( $(hrefModal), $(postProduct) );

          return false;

        });
        //END INIT NAVIGATION MODALS
      }
    },
    'woocommerce_page' : {
      init: function() {

        function ajax_cart_count(){
          var data = {
            'action': 'ajax_cart_count',
          };
          $.post( woocommerce_params.ajax_url, data, function( response ) {
            if(response){
              var shop = $('.banner #shop'),
              count = shop.find('.header-cart-count');
              count.text(parseInt(response));
            }
          });
        }

        // Add to cart
        function addToCart(product_id, quantity, id_variation, target, dataMore){
          dataMore = (typeof dataMore === 'undefined') ? 'default' : dataMore;
          var data = {
            'action': 'ajax_cart',
            'product_id' : product_id,
            'quantity' : quantity,
            'id_variation' : id_variation
          };

          if(dataMore !== 'default'){
            var formattedFormData = {'action': 'ajax_cart'};
            dataMore.map(function(data){
              formattedFormData[data.name] = data.value;
            });
            data = formattedFormData;
          }

          $.post( woocommerce_params.ajax_url, data, function( response ) {
            if(response){
              var shop = $('.banner #shop');
              if(dataMore !== 'default'){
                $('#shop_container').html($(response).find('#shop_container').html());
              }else{
                $('#shop_container').replaceWith($(response));
              }
              target.removeClass('loading');
              ajax_cart_count();
              setTimeout(function () {
              	target.parents('.modalCremant').fadeOut('fast');
              	$('body').removeClass('noOverflow');
                $('#headerCart').addClass('active');
              }, 800);
            }
          });
        }

        $(document).on('click','.single_add_to_cart_button',function(event) {
          event.preventDefault();
          //Params
          var _this = $(this),
          id_product,
          id_variation = 0,
          target = _this,
          quantity = 1,
          dataMore;

          _this.addClass('loading');

          if(_this.hasClass('wc-bookings-booking-form-button')){

            // Booking product
            // console.log('// Booking product');
            id_product = _this.parents('.cart').find('.wc-booking-product-id');
            dataMore = $('form.cart').serializeArray();
          }else if (_this.parents('.woocommerce-variation-add-to-cart').hasClass('woocommerce-variation-add-to-cart')){

            // console.log('// Non booking product with variation');

            var parent = _this.parents('.woocommerce-variation-add-to-cart');
            id_product = parent.find('.product_id').val();
            id_variation = parent.find('.variation_id').val();
            quantity = _this.prev('.quantity').find('.qty').val();

          }else{

            // console.log('// Normal product');

            id_product = _this.val();
            quantity = _this.prev('.quantity').find('.qty').val();

          }
          addToCart(id_product, quantity, id_variation, target, dataMore);
        });
      }
    },
    'reservation': {
      init: function() {
        //INIT HIDDEN VALUES
        $('input.hiddenOffre').val($('.dropdown-offre .dropdown-toggle').html());
        $('input.hiddenFormule').val($('.dropdown-formule .dropdown-toggle').html());
        //END INIT HIDDEN VALUES

        //DROPDOWN SELECT
        $('.dropdown-item').on('click', function(){
          htmlDropdown = $(this).html();
          parentDropdown = $(this).parents('.dropdown');
          parentDropdownMenu = $(this).parent('.dropdown-menu');
          $(parentDropdownMenu).find('.dropdown-item').removeClass('active');
          parentDropdown.children('.dropdown-toggle').html(htmlDropdown);
          $(this).addClass('active');

          if(parentDropdown.hasClass('dropdown-offre')) {
            var idDropdown = '#'+$(this).attr('rel');
            $('.dropdown-formule').hide();
            $(idDropdown).show();
          }
        });
        //END DROPDOWN SELECT

        //NAV STEPS
        $('.goto-reservation-step-2').on('click', function(e){
          e.preventDefault();
          var purl = $('.dropdown-formule:visible > div > a.active').data('url');
          window.location = purl;
        });

        //END NAV STEPS
        var radioInline = $('.radio-inline');
        radioInline.on('click', function(){
          radioInline.removeClass('active');
          $(this).addClass('active');
        });

        radioInline.each(function(){
          var _this = $(this);
          if(_this.find('input').is(':checked')){
            _this.addClass('active');
          }
        });
      }
    },
    'single_product': {
      init: function () {
        // Update 'book' button destination from languages selector.
        $( '#booking-lang-selector' ).change(function() {
          var _this = $(this),
              selector_val = _this.find(":selected").val(),
              calendar = $('.wc-bookings-date-picker'),
              activeDate = calendar.find('.ui-state-active');
          activeDate.trigger( "click" );
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
